import { findOption, type WizardState } from './schema';
import { resolveConfig } from './resolve';

/**
 * Filas legibles [etiqueta, valor] que resumen la configuración actual.
 * Compartido por el wizard (paso Resumen) y la ficha técnica (Fase 6).
 */
export function configSummaryRows(state: WizardState): Array<[string, string]> {
  const cfg = resolveConfig(state);
  const colorOpt = findOption('color-estructura', state['color-estructura'] as string);
  const lamasOpt = findOption('color-lamas', state['color-lamas'] as string);
  const tipo = findOption('tipo', state['tipo'] as string)?.label ?? '';
  const anclaje = findOption('anclaje', state['anclaje'] as string)?.label ?? '';
  const postes = findOption('postes', state['postes'] as string)?.label ?? '';

  // Cerramientos por lado (los que no sean "ninguno").
  const sideKeys: Array<[string, string]> = [
    ['screen-frontal', 'Frontal'],
    ['screen-trasero', 'Trasero'],
    ['screen-izquierda', 'Izquierdo'],
    ['screen-derecha', 'Derecho'],
  ];
  const lados = sideKeys
    .filter(([k]) => (state[k] as string) && state[k] !== 'ninguno')
    .map(([k, name]) => `${name}: ${findOption(k, state[k] as string)?.label ?? ''}`);

  const extras: string[] = [];
  if (state['led'] === 'si') {
    const lc = findOption('led-color', state['led-color'] as string)?.label ?? '';
    extras.push(`LED (${lc})`);
  }
  if (state['sensor'] === 'si') extras.push('Sensor viento/lluvia');
  if (state['motor'] === 'si') extras.push('Motorización lamas');

  return [
    ['Tipo', tipo],
    ['Medidas', `${cfg.widthMm} × ${cfg.lengthMm} mm`],
    ['Altura', `${cfg.heightMm} mm`],
    ['Anclaje', anclaje],
    ['Postes', postes],
    ['Color estructura', `${colorOpt?.ral ?? ''} · ${colorOpt?.label ?? ''}`],
    ['Color lamas', `${lamasOpt?.ral ?? ''} · ${lamasOpt?.label ?? ''}`],
    ['Cerramientos', lados.length ? lados.join(', ') : '—'],
    ['Extras', extras.length ? extras.join(', ') : '—'],
  ];
}
